/***************************************************************
5/27/2017
Alexander Self
Timesheet edit modal
- Summary of edited timesheet to be submitted; used as a check prior to
  submitting timesheets
***************************************************************/
import TimesheetEmployeeTable from '../create/timesheet_modal_emp_table';
import TimesheetWorkTable from '../create/timesheet_modal_work_table';
import TimesheetHarvestTable from '../create/timesheet_gang_harvest_table';
import React from 'react';
const $ = window.$;

const TimesheetEditModal = ({ id, employee, timesheet, removedWork, subTimesheets, submitTimesheet, harvestTimesheet, removedHarvest }) => {
  $(document).ready(() => {
    $(`#${id}`).modal();
  });
  let _sub = subTimesheets.reduce((acc, cur) => { return acc + Number(cur.hours) }, 0);
  let harv = harvestTimesheet.reduce((acc, cur) => { return acc + Number(cur.hours) }, 0);
  let work = _sub + harv;
  if (timesheet === undefined || Object.keys(timesheet).length === 0) {
    return (
      <div id={id} className="modal modal-fixed-footer">
        <div className="modal-content">
          <h4>Edit Timesheet Summary</h4> <hr />
          <p>No employee selected</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="modal-action modal-close waves-effect waves-red btn-flat">Cancel</button>
        </div>
      </div>
    )
  }
  return (
    <div id={id} className="modal modal-fixed-footer">
      <div className="modal-content">
        <h4>Edit Timesheet Summary</h4> <hr />
        { work > 12 ? <h4 className="day-off">Total hours are: {work}. Is this correct?</h4> : '' }
        { work < 8 ? <h4 className="day-off">Total working hours are: {work}. Is this correct?</h4> : '' }
        <h5>Reason for Edit: { timesheet.reasonForEdit ? <b className="blue-text">{ timesheet.reasonForEdit }</b> : <b>...</b> }<br /></h5>
        <blockquote>
          <div className="row">
            <div className="col s12 m12 l12">
              <ul className="collection flow-text">
                <li className="collection-item">Date: <b><span className="right">{ timesheet.date ? timesheet.date.split('T')[0] : '' }</span></b></li>
                <li className="collection-item">Location: <b><span className="right">{ timesheet.location }</span></b></li>
                <li className="collection-item">Start Time: <b><span className="right">{ timesheet.startTime ? timesheet.startTime : '' }</span></b></li>
                <li className="collection-item">End Time: <b><span className="right">{ timesheet.endTime ? timesheet.endTime : '' }</span></b></li>
                <li className="collection-item">Gang No: <b><span className="right">{ timesheet.gang ? timesheet.gang : '' }</span></b></li>
              </ul>
            </div>
          </div>
        </blockquote>
        <div className="row">
          {
            Object.keys(employee).length > 0 ?
              <TimesheetEmployeeTable timesheet={timesheet} employees={[employee]} />
            : ''
          }
          
        </div>
        {
          subTimesheets.length > 0 ?
          <div className="row">
            <hr />
            <span className="flow-text">Individual Work</span>
            <TimesheetWorkTable workPerformed={subTimesheets} />
          </div> : ''
        }
        {
          harvestTimesheet.length > 0 ?
          <div className="row">
            <hr />
            <span className="flow-text">Harvest</span>
            <TimesheetHarvestTable harvest={harvestTimesheet} />
          </div> : ''
        }
      </div>
      <div className="modal-footer">
        <button type="button" className="modal-action modal-close waves-effect waves-red btn-flat">Cancel</button>
        <button type="button" onClick={() => submitTimesheet({ timesheet, subTimesheets, removedWork, employee, harvestTimesheet, removedHarvest })}
          className="modal-action modal-close waves-effect waves-green btn-flat">
          Submit
        </button>
      </div>
    </div>
  );
};

export default TimesheetEditModal;



// WEBPACK FOOTER //
// ./src/components/timesheets/edit/timesheet_edit_modal.js